import { Component, OnInit, Input } from '@angular/core';
import { isBrowser } from 'angular2-universal';
import { CartService } from './cart.service';
import { UtilsService } from '../shared/utils.service';
import { ConfigService } from '../shared/config.service';

declare var $: any;
declare let paypal: any;

@Component({
    selector: 'payment-paypal-express-checkout',
    template: '<div class="text-right" id="paypal-button-container"></div>',
})
export class PaymentPayPalExpressCheckoutComponent implements OnInit {
    
    @Input() language: string;

    constructor(private cartService: CartService, private utils: UtilsService, private configService: ConfigService) {
    }

    transactionItems(){
        let items = [];
        for(let item of this.cartService.items){
            items.push({
                sku: item.content.reference,
                name: item.content.title.substring(0, 126),
                quantity: item.qty,
                price: item.content.price,
                currency: 'EUR'
            });
        }
        return items;
    }

    ngOnInit(){
        console.log(this.configService)
        if (isBrowser) {
            $.getScript( 'https://www.paypalobjects.com/api/checkout.js', () => {
                paypal.Button.render({
                    // environment
                    env: this.configService.data.CART.PAYPAL.ENV, // sandbox | production 
                    // style of the button
                    style: {
                        label: 'checkout', // checkout | credit | pay
                        size: 'responsive',    // small | medium | responsive
                        shape: 'rect',     // pill | rect
                        color: 'blue'      // gold | blue | silver
                    },
                    client: {
                        sandbox: 'AQNZSlVenpCKXfVDWSO-yDVMTDRlx_yiRK0drTN-AGmJQl0FdUR2sJFrjLuFCeIEN1S-rpsw-EJh21SM',
                        production: 'AQFZ3hsSn5_-qpeffTa69yKgzE6-mOCorPNSKkePo2Y3LXdc9fhB5AGu60XopuZNXy2rn5iifFmcX2iA'
                    },
                    locale: this.utils.toLocale(this.language), 
                    payment: (data, actions) => {
                        return actions.payment.create({
                            payment: {
                                transactions: [
                                    {
                                        amount: { 
                                            total: this.cartService.total(), 
                                            currency: 'EUR',
                                            details:{
                                                subtotal: this.cartService.subtotal(),
                                                shipping: this.cartService.shipping()
                                            }
                                        },
                                        item_list: {
                                            items: this.transactionItems()
                                        }   
                                    }
                                ]
                            }
                        });
                    },
                    onAuthorize: (data, actions) => {
                        return actions.payment.execute().then(() => {
                            this.cartService.paymentData = data;
                            this.cartService.clear();
                        });

                    }

                }, '#paypal-button-container');
            });
        }
    }

}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/front/payment-paypal-express-checkout.component.ts